import { render } from "./UnconfiguredProductsView.vue?vue&type=template&id=12bb3125"
import script from "./UnconfiguredProductsView.vue?vue&type=script&lang=js"
export * from "./UnconfiguredProductsView.vue?vue&type=script&lang=js"

import "./UnconfiguredProductsView.vue?vue&type=style&index=0&id=12bb3125&lang=css"

import exportComponent from "/srv/git/index-webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__